import React from 'react';

import { FineDetails, OrderSummaryText } from '../style';

type PaymentSubtotalProps = {
    item: string;
    amount: string;
};

export default function PaymentSubtotal({ item, amount }: PaymentSubtotalProps) {
    return (
        <>
            <FineDetails>
                <OrderSummaryText>{item}</OrderSummaryText>
                <OrderSummaryText> 
                    {amount}
                </OrderSummaryText>
            </FineDetails>
        </>
    );
}
